function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.607 27.632a3.21 3.21 0 002.671-1.43l4.867-7.3a3.21 3.21 0 00.54-1.782V8.21A3.21 3.21 0 0017.474 5H4.947A3.947 3.947 0 001 8.948v5.894a3.947 3.947 0 003.947 3.948h2.549A1.21 1.21 0 018.69 20.2l-.616 3.694a3.21 3.21 0 003.167 3.738h1.366zM27.79 18.79A3.21 3.21 0 0031 15.579V8.21A3.21 3.21 0 0027.79 5h-1.474a3.21 3.21 0 00-3.21 3.21v7.369a3.21 3.21 0 003.21 3.21h1.473z",
  fill: "currentColor"
})));